import angular from 'angular';
import 'angular-ui-bootstrap';

import translationsModuleName from '../../../../../lib/translation';

// Component
import component from './dashboardNotifications.component';

import uibAlertModuleName from 'angular-ui-bootstrap/src/alert';

const moduleName = 'staff.dashboardScreen.dashboardNotifications';
let module = angular.module(moduleName, [
  translationsModuleName,
  uibAlertModuleName,
]);

module.component('dashboardNotifications', component);

export default module;
